// tslint:disable:no-string-literal
import { Col, Form, Row, Select } from 'antd';
import Button from 'antd/lib/button/button';
import Input from 'antd/lib/input/Input';
import * as React from 'react';
import { getPrivilegesTo } from 'src/helpers/Users/getPrivilegesTo';
import { privileges } from 'data-layer/src/services/Users/privileges';
import { FormItem } from '../../../../../components/Form';
import PricesWithDiscountInput from 'src/components/Others/PricesWithDiscountInput';
import DiscountInput from 'src/components/Others/DiscountInput';
import { AvailabilitySelect } from 'src/scenes/Availabilities';

export interface IEditorProps {
  attributes: Array<GQL.IAttribute>;
  allAttributes: Array<GQL.IAttribute>;
  variant?: GQL.IProductVariant;
  onChange: (variant: GQL.IProductVariant) => void;
  onSave: () => void;
  onDismiss: () => void;
  editMode: boolean;
  dismissable: boolean;
  errors: { [id: string]: string };
}

interface IEditorState {
  newAttributes: Array<GQL.IAttribute>;
}

export default class Editor extends React.PureComponent<IEditorProps, IEditorState> {

  constructor(props: IEditorProps) {
    super(props);

    this.state = {
      newAttributes: [],
    };

    this.onSave = this.onSave.bind(this);
    this.onDismiss = this.onDismiss.bind(this);
  }

  public render() {

    const attributes = [...this.props.attributes];
    if (this.state.newAttributes) {
      this.state.newAttributes.forEach((na: GQL.IAttribute) => {
        if (!attributes.find(a => a.id === na.id)) {
          attributes.push(na);
        }
      })
    }

    const privilegesToPrices = getPrivilegesTo(privileges.CHANGE_PRODUCT_PRICE);

    const { variant } = this.props;

    return (
      <div>
        <Row>
          <Col md={24}>
            <Form.Item style={{ marginBottom: '5px' }}>
              <Select
                style={{ width: '300px' }}
                value={undefined}
                placeholder={'Add new attribute'}
                onChange={(value: string) => {
                  this.updateVariantDefinition(
                    value.toString(),
                    []
                  );

                  const newAttributes = [...this.state.newAttributes];
                  const newAttribute = this.props.allAttributes.find(a => a.id === value);
                  if (newAttribute) {
                    newAttributes.push(newAttribute);
                  }

                  this.setState({
                    newAttributes: newAttributes,
                  });
                }}
              >
                {this.props.allAttributes &&
                  this.props.allAttributes
                    .filter(a => !this.props.attributes.find(pa => pa.id == a.id))
                    .map((attribute: GQL.IAttribute) => (
                      <Select.Option
                        key={attribute.id}
                        value={attribute.id}
                      >
                        {attribute.title}
                      </Select.Option>
                    ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row>
          {attributes.map(attribute => {
            const { variant } = this.props;
            const attributeValueOrValues =
              variant && variant.definition && variant.definition[attribute.id];

            if (Array.isArray(attributeValueOrValues)) {
              return (
                <Col key={attribute.id} md={4}>
                  <Form.Item
                    validateStatus={
                      this.props.errors[attribute.id] != undefined ? 'error' : undefined
                    }
                    help={this.props.errors[attribute.id.toString()]}
                    label={attribute.title}
                  >
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      {attributeValueOrValues.map((valueId, index) => {
                        return (
                          <div style={{ flexDirection: 'row' }} key={valueId}>
                            <Select
                              allowClear={false}
                              style={{ width: '80%' }}
                              value={valueId}
                              onChange={(value: string) => {
                                if (!attributeValueOrValues.some(v => v == value)) {
                                  const newAttributeValues = [...attributeValueOrValues];
                                  newAttributeValues[index] = value;
                                  this.updateVariantDefinition(attribute.id.toString(), newAttributeValues);
                                }
                              }}
                            >
                              {(attribute.values || []).map((attributeValue: any) => (
                                <Select.Option
                                  key={attributeValue}
                                  value={attributeValue.id}
                                >
                                  {attributeValue.title}
                                </Select.Option>
                              ))}
                            </Select>
                            {index != 0 && (
                              <Button
                                danger={true}
                                onClick={() =>
                                  this.updateVariantDefinition(
                                    attribute.id.toString(),
                                    attributeValueOrValues.filter(v => v != valueId)
                                  )
                                }
                                icon="close"
                              />
                            )}
                          </div>
                        );
                      })}

                      <Button
                        disabled={attributeValueOrValues.some(v => v == undefined)}
                        onClick={() => {
                          this.updateVariantDefinition(attribute.id.toString(), [
                            ...attributeValueOrValues,
                            undefined
                          ]);
                        }}
                        style={{ width: '80%' }}
                        icon="plus"
                      />
                    </div>
                  </Form.Item>
                </Col>
              );
            }

            return (
              <Col key={attribute.id} md={4}>
                <Form.Item
                  validateStatus={this.props.errors[attribute.id] != undefined ? 'error' : undefined}
                  help={this.props.errors[attribute.id.toString()]}
                  label={attribute.title}
                >
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <Select
                      allowClear={true}
                      key={attributeValueOrValues}
                      style={{ width: '80%' }}
                      value={attributeValueOrValues}
                      onChange={(value: string) =>
                        this.updateVariantDefinition(attribute.id.toString(), value)
                      }
                    >
                      {(attribute.values || []).map((attributeValue: any) => (
                        <Select.Option key={attributeValue} value={attributeValue.id}>
                          {attributeValue.title}
                        </Select.Option>
                      ))}
                    </Select>
                    <Button
                      disabled={attributeValueOrValues == undefined}
                      onClick={() => {
                        this.updateVariantDefinition(attribute.id.toString(), [
                          attributeValueOrValues,
                          undefined
                        ]);
                      }}
                      style={{ width: '80%' }}
                      icon="plus"
                    />
                  </div>
                </Form.Item>
              </Col>
            );
          })}
          <Col md={4}>
            <Form.Item
              validateStatus={this.props.errors['ean'] != undefined ? 'error' : undefined}
              help={this.props.errors['ean']}
              hasFeedback={true}
              label={'EAN'}
            >
              <Input
                name={'ean'}
                style={{ width: '80%' }}
                value={this.props.variant && this.props.variant.ean}
                onChange={(e: any) => this.updateVariant('ean', e.target.value)}
              />
            </Form.Item>
          </Col>
          <Col md={4}>
            <Form.Item
              validateStatus={this.props.errors['sku'] != undefined ? 'error' : undefined}
              help={this.props.errors['sku']}
              hasFeedback={true}
              label={'Item number'}
            >
              <Input
                name={'sku'}
                style={{ width: '80%' }}
                value={this.props.variant && this.props.variant.sku}
                onChange={(e: any) => this.updateVariant('sku', e.target.value)}
              />
            </Form.Item>
          </Col>
          <Col md={4}>
            <Form.Item
              label={'Availability'}
            >
              <AvailabilitySelect
                // key je nutné, jinak se se availability select neaktualizuje se změnou varianty
                key={'...' + (this.props.variant && this.props.variant.id || ('new' + new Date().toISOString()))}
                name="availabilityId"
                value={this.props.variant && this.props.variant.availabilityId || this.props.variant && this.props.variant.availability && this.props.variant.availability.id || undefined}
                placeholder="Availability"
                onChange={e => {
                  this.updateVariant('availabilityId', e.target.value);
                }}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col md={5}>
            <FormItem
              label={'Recommended price (excl. vat)'}
            >
              <PricesWithDiscountInput
                name={'prices'}
                disabled={!privilegesToPrices}
                mode={'recommendedPriceWithout'}
                sku={variant && variant.sku ? variant.sku : undefined}
                ean={variant && variant.ean ? variant.ean : undefined}
                prices={variant && variant.prices ? variant.prices : []}
                showPurchasePrice={true}
                onChange={(e) => {
                  this.updateVariant('prices', e.target.value);
                }}
                availabilityMode={true}
                stockMode={true}
              />
            </FormItem>
          </Col>
          <Col md={3}>
            <FormItem label={'Discount'}>
              <DiscountInput
                name={'prices'}
                prices={variant && variant.prices ? variant.prices : []}
                onChange={(e: any) => this.updateVariant('prices', e.target.value)}
              />
            </FormItem>
          </Col>
          <Col md={5}>
            <Form.Item
              label={'Minimal price (with discount)'}
            >
              <PricesWithDiscountInput
                name={'prices'}
                disabled={!privilegesToPrices}
                mode={'minimalPrice'}
                sku={variant && variant.sku ? variant.sku : undefined}
                ean={variant && variant.ean ? variant.ean : undefined}
                prices={variant && variant.prices ? variant.prices : []}
                onChange={(e) => {
                  this.updateVariant('prices', e.target.value);
                }}
                showPurchasePrice={true}
                availabilityMode={true}
                stockMode={true}
              />
            </Form.Item>
          </Col>
          <Col md={5}>
            <FormItem label={'Price (excl. vat)'}>
              <PricesWithDiscountInput
                name={'prices'}
                disabled={!privilegesToPrices}
                mode={'priceWithout'}
                sku={variant && variant.sku ? variant.sku : undefined}
                ean={variant && variant.ean ? variant.ean : undefined}
                prices={variant && variant.prices ? variant.prices : []}
                onChange={(e: any) => {
                  this.updateVariant('prices', e.target.value);
                }}
                showPurchasePrice={true}
                availabilityMode={true}
                stockMode={true}
              />
            </FormItem>
          </Col>
        </Row>

        <Row>
          <Col md={4}>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <Button type={this.props.editMode ? 'primary' : undefined} onClick={this.onSave}>
                {this.props.editMode ? 'Update variant' : 'Create variant'}
              </Button>
              {this.props.dismissable && (
                <Button onClick={this.props.onDismiss} type={'ghost'}>
                  Dismiss
                </Button>
              )}
            </div>
          </Col>
        </Row>
      </div>
    );
  }

  private onSave() {
    this.props.onSave();
  }

  private onDismiss() {
    this.props.onDismiss();
  }

  private updateVariant(key: string, value: any) {
    const newVariant = { ...this.props.variant, [key]: value };

    this.props.onChange(newVariant as GQL.IProductVariant);
  }

  private updateVariantDefinition(key: string, tempValue: string | string[]) {
    // const { attributes } = this.props;
    // const visualAttribute = attributes.find(a => a.id == key && a.isVisual);

    let value = tempValue;
    // if (Array.isArray(value)) {
    //     value = value.filter(v => v != undefined);
    // }

    let definition = { [key.toString()]: value };
    /*if (visualAttribute) {
      definition = { ...definition, visual: value };
    }*/

    if (this.props.variant) {
      // if we are editing existing variant
      definition = {
        ...this.props.variant.definition,
        [key.toString()]: value
      };

      /*if (visualAttribute) {
        definition = {
          ...definition,
          visual: value
        };
      }*/
    }

    const newVariant = {
      ...this.props.variant,
      definition
    };

    this.props.onChange(newVariant as GQL.IProductVariant);
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Products/ProductDetail/ProductVariantsTab/ProductCombinationsTable/Editor.tsx